import { useState, useEffect } from 'react';
import Select from 'react-select';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { fetchExistingLabTypes } from '../ApiHandler/labFunctions';
import { fetchActiveSchools } from '../ApiHandler/schoolFunctions';
import { handleAddLab, handleEditLabData } from '../ApiHandler/labFunctions';

const AddLab = ({ editFormData, handleClose }) => {
    const isEditing = !!editFormData;
    const [labData, setLabData] = useState({
        labName: editFormData ? editFormData.lab_name || "" : "",
        labType: editFormData ? editFormData.lab_type_id || "" : "",
        labCapacity: editFormData ? editFormData.lab_capacity || "" : "",
        labDescription: editFormData ? editFormData.lab_description || "" : "",
        schoolId: editFormData ? editFormData.school_id || "" : "",
    });

    const [schoolNames, setSchoolNames] = useState([]);
    const [labTypes, setLabTypes] = useState([]);

    
    const handleFormSubmit = async (e) => {
        e.preventDefault();
        if (isEditing) {
            const mappedData = {
                lab_name: labData.labName,
                lab_type_id: labData.labType,
                lab_capacity: labData.labCapacity,
                lab_description: labData.labDescription,
                school_id: labData.schoolId
            };
            await handleEditLabData(e, editFormData.id, mappedData);
            if (handleClose) handleClose();
        } else {
            handleAddLab(e, labData, setLabData);
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setLabData(prevData => ({
            ...prevData,
            [name]: value
        }));
    };

    useEffect(() => {
        fetchActiveSchools(setSchoolNames);
        fetchExistingLabTypes(setLabTypes);
    }, []);

    return (
        <div className="upload-document-container">
            <ToastContainer />
            <header className="upload-document-header">
                <h1>{isEditing ? 'Edit Lab Data' : 'Tag Lab to School'}</h1>
            </header>
            <form className="upload-document-form" onSubmit={handleFormSubmit}>
                <div className="form-group">
                    <label>Lab Name <m style={{ color: 'red' }}>*</m></label>
                    <input
                        type="text"
                        name="labName"
                        value={labData.labName}
                        onChange={handleChange}
                        placeholder="Enter Lab Name"
                        autoComplete='off'
                        required
                    />
                </div>
                <div className="form-group">
                    <label>Lab Type <m style={{ color: 'red' }}>*</m></label>
                    <select name="labType" value={labData.labType} onChange={handleChange} required>
                        <option value="">Select</option>
                        {labTypes.map((type) => (
                            <option key={type.lab_type_id || type.id} value={type.lab_type_id || type.id}>{type.lab_type_name || type.lab_name}</option>
                        ))}
                    </select>
                </div>
                <div className="form-group">
                    <label>Lab Capacity <m style={{ color: 'red' }}>*</m></label>
                    <input
                        type="text"
                        name="labCapacity"
                        value={labData.labCapacity}
                        onChange={(e) => {
                            if (/^\d{0,3}$/.test(e.target.value)) {
                                handleChange(e);
                            }
                        }}
                        placeholder="No. of students can be accommodated in this lab"
                        autoComplete='off'
                    />
                </div>
                <div className="form-group">
                    <label>Lab Description <m style={{ color: 'red' }}>*</m></label>
                    <textarea
                        type="text"
                        name="labDescription"
                        value={labData.labDescription}
                        onChange={handleChange}
                        maxLength="500"
                        placeholder="Enter Lab Description"
                        autoComplete='off'
                        required
                    />
                    <label style={{ color: 'red', fontWeight: '350', fontSize: '12px' }}>Maximum Characters: 500</label>
                </div>
                <div className="form-group">
                    <label>School Name <m style={{ color: 'red' }}>*</m></label>
                    <Select
                        options={schoolNames.map(school => ({ value: school.id, label: school.school_name }))}
                        value={schoolNames.map(school => ({ value: school.id, label: school.school_name })).find(option => option.value === labData.schoolId) || null}
                        onChange={(selectedOption) => {
                            handleChange({
                                target: {
                                    name: 'schoolId',
                                    value: selectedOption ? selectedOption.value : ''
                                }
                            });
                        }}
                        placeholder="Select"
                        isClearable
                        required
                    />
                </div>
                <div className="form-group">
                    <button type="submit">{isEditing ? 'Update' : 'Submit'}</button>
                    {isEditing && <button type="button" onClick={handleClose} style={{marginLeft: '10px', backgroundColor: '#6c757d'}}>Cancel</button>}
                </div>
            </form>
        </div>
    );
};

export default AddLab;
